module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921102649_T.2069c01d.jpg";